import React from 'react';
     import '/vercel/path0/docs/guide/page-config.md?watch=parent';
export const demos = {
  'docs-guide-page-config-demo-foo': {
    component: React.memo(React.lazy(() => import( /* webpackChunkName: "demos" */ '/vercel/path0/docs/guide/demos/cols.tsx?techStack=react'))),
    asset: {
  "type": "BLOCK",
  "id": "docs-guide-page-config-demo-foo",
  "refAtomIds": [],
  "dependencies": {
    "index.tsx": {
      "type": "FILE",
      "value": require('/vercel/path0/docs/guide/demos/cols.tsx?dumi-raw').default
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    }
  },
  "entry": "index.tsx",
  "title": "分栏 1"
},
    context: {
  "react": require('react')
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/vercel/path0/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
  'docs-guide-page-config-demo-bar': {
    component: React.memo(React.lazy(() => import( /* webpackChunkName: "demos" */ '/vercel/path0/docs/guide/demos/cols.tsx?techStack=react'))),
    asset: {
  "type": "BLOCK",
  "id": "docs-guide-page-config-demo-bar",
  "refAtomIds": [],
  "dependencies": {
    "index.tsx": {
      "type": "FILE",
      "value": require('/vercel/path0/docs/guide/demos/cols.tsx?dumi-raw').default
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    }
  },
  "entry": "index.tsx",
  "title": "分栏 2"
},
    context: {
  "react": require('react')
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/vercel/path0/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
  'docs-guide-page-config-demo-baz': {
    component: React.memo(React.lazy(() => import( /* webpackChunkName: "demos" */ '/vercel/path0/docs/guide/demos/cols.tsx?techStack=react'))),
    asset: {
  "type": "BLOCK",
  "id": "docs-guide-page-config-demo-baz",
  "refAtomIds": [],
  "dependencies": {
    "index.tsx": {
      "type": "FILE",
      "value": require('/vercel/path0/docs/guide/demos/cols.tsx?dumi-raw').default
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    }
  },
  "entry": "index.tsx",
  "title": "分栏 3"
},
    context: {
  "react": require('react')
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/vercel/path0/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
  'docs-guide-page-config-demo-other': {
    component: React.memo(React.lazy(() => import( /* webpackChunkName: "demos" */ '/vercel/path0/docs/guide/demos/cols.tsx?techStack=react'))),
    asset: {
  "type": "BLOCK",
  "id": "docs-guide-page-config-demo-other",
  "refAtomIds": [],
  "dependencies": {
    "index.tsx": {
      "type": "FILE",
      "value": require('/vercel/path0/docs/guide/demos/cols.tsx?dumi-raw').default
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    }
  },
  "entry": "index.tsx",
  "title": "分栏 4"
},
    context: {
  "react": require('react')
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/vercel/path0/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
};